import { MutationTree } from 'vuex';

import {
  SubsStateI,
  SubI,
} from './state';

export const mutations: MutationTree<SubsStateI> = {
  setSub(state: SubsStateI, payload: SubI) {
    state.sub = payload;
  },
};
